<template>
  <b-form-group :label-sr-only="noLabel">
    <template #label>
      <span>{{ $t(label) }}</span>
      <span v-if="required && label" class="text-danger">*</span>
    </template>
    <b-input-group>
      <editor
        ref="campo"
        style="width: 100%;"
        :editorStyle="`height: ${height}`"
        :modules="editorConfig.modules"
        v-model="internalValue"
        @input="updateInternalValue"
      />
    </b-input-group>
    <b-form-invalid-feedback :state="state">{{ feedback }}</b-form-invalid-feedback>
  </b-form-group>
</template>

<script>
import Quill from 'quill';
import ImageResize from 'quill-image-resize-module';
import { ImageDrop } from 'quill-image-drop-module';
import Editor from 'primevue/editor';
import 'primevue/resources/themes/saga-blue/theme.css';
import 'primevue/resources/primevue.min.css';
import 'primeicons/primeicons.css';

// Registra o módulo ImageResize com configurações para o redimensionamento
Quill.register('modules/imageResize', ImageResize);
Quill.register('modules/imageDrop', ImageDrop);
const Size = Quill.import('attributors/style/size');
Size.whitelist = ['small', 'normal', 'large', 'huge'];
Quill.register(Size, true);

export default {
  components: {
    Editor,
  },
  props: {
    value: {
      type: String,
      required: true,
    },
    height: { type: String, default: '350px' },
    label: { type: String },
    noLabel: { type: Boolean, default: false },
    required: { type: Boolean },
  },
  data() {
    return {
      internalValue: this.value,
      validarFormulario: false,
      hasError: false,
      errorMessage: '',
      isField: true,
      editorConfig: {
        modules: {
          toolbar: [
            [{ font: ['serif', 'sans-serif', 'monospace'] }], // Opções de fonte incluindo "Arial"
            [{ size: ['small', false, 'large', 'huge'] }], // Dropdown para tamanhos de fonte
            ['bold', 'italic', 'underline', 'strike'],
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ align: [] }],
            ['link', 'blockquote', 'code-block'],
            [{ color: [] }, { background: [] }],
          ],
          imageDrop: true,
          imageResize: {
            // Configurações adicionais para habilitar o redimensionamento
            displayStyles: {
              backgroundColor: 'black',
              border: 'none',
              color: 'white',
            },
            modules: ['Resize', 'DisplaySize'], // Ativa redimensionamento e exibição do tamanho
          },
        },
      },
    };
  },
  computed: {
    requiredValid() {
      return !(this.required && !this.value);
    },
    state() {
      if (!this.validarFormulario) return null;
      if (!this.requiredValid || this.hasError) return false;
      return true;
    },
    feedback() {
      if (!this.requiredValid) {
        return (
          this.requiredMessage ||
          this.$t('CAMPOS_VALIDACAO.REQUERIDO').formatUnicorn({ name: this.label })
        );
      }
      return this.hasError ? this.errorMessage : '';
    },
  },
  watch: {
    value(newValue) {
      this.internalValue = newValue;
    },
  },
  methods: {
    updateInternalValue(value) {
      this.internalValue = value;
      this.$emit('input', value);
    },
    valid() {
      this.validarFormulario = true;
      return this.state;
    },
  },
};
</script>

<style>
/* Estilos para melhor controle visual dos elementos */
.p-editor-toolbar {
  display: none;
}
.quillWrapper {
  overflow: hidden;
  border: 1px solid rgba(34, 36, 38, 0.15) !important;
  border-radius: 8px !important;
  border-radius: 0.28571429rem;
  width: 100%;
  background-color: white;
}

.quillWrapper .ql-snow.ql-toolbar {
  border-radius: 8px 8px 0 0;
}

/* .quill-container {
  border: 0 !important;
}

.ql-container.ql-snow {
  border: 0 !important;
} */

.quillWrapper > .ql-toolbar.ql-snow {
  border: 0 !important;
  border-bottom: 1px solid rgba(34, 36, 38, 0.15) !important;
}

.ql-font-sans-serif {
  font-family: Arial, sans-serif !important;
}
</style>
